module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fc-Gc-Hc-Ia.859f6f6a.png";